<template>
    <div class="card">
        <div v-if="title" class="card-header">
            {{ title }}
        </div>
        <div class="card-body" :style="{padding: padding}">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppCard',
    props: {
        title: {
            type: String,
            default: null
        },
        padding: {
            type: String,
            default: '0.9375rem'
        }
    }
};
</script>
